import LinkedMemberCont from '../../../components/Main/Group/LinkedMember/LinkedMemberCont'
import RolesListCont from '../../../components/Main/Group/Roles/RolesListCont'
import React from 'react'
import { Modal, Tabs } from 'antd'
import History from '../../../components/Common/History'
import DocumentsCont from '../../../components/Common/Documents/DocumentsCont'
import GroupForm from '../../../components/Main/Group/GroupForm'
import FooterButton from '../../../elements/Buttons/FooterButtons'

const { TabPane } = Tabs

function GroupModal (props) {
  const {
    visible,
    modalType,
    onCancel,
    submit,
    submitting,
    update,
    remove,
    removing,
    group,
    fetching,
    formRef,
  } = props
  console.log({ modalType })
  const isEdit = modalType === 'edit'
  const isNew = modalType !== 'edit'

  return (
    <Modal
      title={isNew ? 'Create New Group' : 'Update Group'}
      destroyOnClose={true}
      visible={visible}
      onCancel={onCancel}
      width={'95%'}
      footer={
        <FooterButton
          remove={remove}
          removing={removing}
          submit={submit}
          submitting={submitting}
          update={update}
          title={'Group'}
          isEdit={modalType === 'edit'}
          isNew={modalType === 'new'}
        />
      }>
      <Tabs defaultActiveKey="details">
        <TabPane tab="Details" key="details">
          <GroupForm ref={formRef} loading={fetching} group={group} {...props} />
          <RolesListCont group={group}/>
        </TabPane>
        <TabPane tab="Members" key="members">
          <LinkedMemberCont disabled={isNew} group={group}/>
        </TabPane>
        <TabPane disabled={isNew} tab="History" key="history">
          <History owner={group}/>
        </TabPane>
        <TabPane disabled={isNew} tab="Files" key="files">
          <DocumentsCont editable={isEdit} footer={false} category={false} owner={group}/>
        </TabPane>
      </Tabs>
    </Modal>
  )
}

GroupModal.propTypes = {}
GroupModal.defaultProps = { group: {} }

export default GroupModal
